import { clamp } from 'lodash';
import { type JSX, memo } from 'react';
import type { XY } from 'src/lib/player/store';
import tinycolor from 'tinycolor2';
import type { Bounds } from '../InfoSheet/SVGChart';
import {
  getInterpolatedElevation,
  getInterpolatedY,
  projectX,
  type ViewRange,
} from './heightChartUtils';

export const HeightChartProgressPolyline = memo(function HeightChartProgressPolyline({
  filteredTrack,
  viewRange,
  bounds,
  progress,
  lineColor,
}: {
  filteredTrack: Array<XY>;
  viewRange: ViewRange;
  bounds: Bounds;
  progress: number;
  lineColor: string;
}): JSX.Element {
  const { minX, maxX, minY, maxY } = viewRange;
  const cutoffX = clamp(progress, minX, maxX);
  if (cutoffX <= minX) return <></>;
  const trackOnlyUpToProgress = filteredTrack.filter(
    (point) => point.x >= minX && point.x <= cutoffX,
  );
  const leftEdgeY = getInterpolatedElevation(filteredTrack, minX);
  const rightEdgeY = getInterpolatedElevation(filteredTrack, cutoffX);
  const clipped = [
    { x: minX, y: minY },
    { x: minX, y: Number.isNaN(leftEdgeY) ? minY : leftEdgeY },
    ...trackOnlyUpToProgress,
    { x: cutoffX, y: Number.isNaN(rightEdgeY) ? minY : rightEdgeY },
    { x: cutoffX, y: minY },
  ];

  return (
    <polygon
      points={clipped
        .map(
          (point) =>
            `${projectX(point.x, viewRange, bounds)} ${getInterpolatedY(
              point.y,
              minY,
              maxY,
              bounds,
            )}`,
        )
        .join(' ')}
      fill={tinycolor(lineColor).setAlpha(0.6).toRgbString()}
      stroke={lineColor}
      strokeWidth={1}
    />
  );
});
